export default __webpack_public_path__ + "static/media/Arm_right.c9d27f3d.svg";